import { render, staticRenderFns } from "./addstock.vue?vue&type=template&id=44f23df8"
import script from "./addstock.vue?vue&type=script&lang=js"
export * from "./addstock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports